import { render, staticRenderFns } from "./BtnSyncInvoice.yaml?vue&type=template&id=7bdcc7da&component"
import script from "./BtnSyncInvoice.yaml?vue&type=script&lang=ts&component"
export * from "./BtnSyncInvoice.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports